// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__m6OiU","selected":"Chip_selected__1mxh9"};